import { Component } from '@angular/core';

@Component({
  selector: 'app-franchises',
  template: `<router-outlet></router-outlet>`,
})
export class FranchisesComponent {
  constructor() { }
}
